"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Ethically sourced from https://github.com/pixlee/lego
 * See readme for more info
 */
var expandObj = function expandObj(obj) {
  return Object.entries(obj).reduce(function (className, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return value ? "".concat(className, " ").concat(key) : className;
  }, '').trimStart();
};

var expandArray = function expandArray(arr) {
  return arr.reduce(function (className, arg) {
    return classes(className, arg);
  }, '').trimStart();
};

var expandValidType = function expandValidType(arg) {
  if (Array.isArray(arg)) {
    return expandArray(arg);
  }

  if (_typeof(arg) === 'object') {
    return expandObj(arg);
  }

  return arg;
};
/**
 * @example
 * ```js
 * function buttonClasses(large = false) {
 *   const classObj = {
 *     large: large,
 *     flex: true,
 *     float: false,
 *   };
 *   const isPrimary = true;
 *   return classes('btn', isPrimary && 'primary', classObj);
 * }
 *
 * buttonClasses();
 * // > className === 'btn primary flex'
 *
 * buttonClasses(true);
 * // > className === 'btn primary large flex'
 * ```
 *
 * @param args
 *
 */


var classes = function classes() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (className, arg) {
    return arg ? "".concat(className, " ").concat(expandValidType(arg)) : className;
  }, '').trimStart();
};

exports.classes = classes;